export const PORTALS = [
  {
    id: "valor",
    name: "Valor PayTech",
    title: "Valor PayTech Portal",
    desc: "Sign in to your Valor PayTech merchant account.",
    url: "https://online.valorpaytech.com/login",
  },
  {
    id: "payarc",
    name: "PAYARC",
    title: "PAYARC Merchant Dashboard",
    desc: "View transactions, refunds, deposits and reports.",
    url: "https://dashboard.payarc.net/signin",
  },
  {
    id: "netevia",
    name: "Netevia",
    title: "Netevia HQ",
    desc: "Access statements, reporting and account details.",
    url: "https://hq.netevia.com/Account/Login",
  },
];
